import { Component, inject } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import {
  selectEntrepriseProduct,
  selectFreeProduct,
  selectProProduct,
} from '../../store/products/products.selects';
import { BehaviorSubject, Observable } from 'rxjs';
import { Product } from '../../class/planProduct.class';
import { PricingComponent } from '../../components/pricing/pricing.component';
import { ButtonComponent } from '../../components/boutons/button/button.component';
import { ResponsiveService } from '../../services/reponsive.service';
import { AsyncPipe, NgClass } from '@angular/common';
import { LoginService } from '../../services/login.service';
import { OpeningComponent } from '../../components/landingPage/opening/opening.component';
import { ActivatedRoute, Params, Router, RouterLink } from '@angular/router';
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { AuthRegisterResponse } from '../../models/auth-register-response.model';
import { FooterComponent } from '../../components/footer/footer.component';
import { DemoPlayerComponent } from '../../components/demo-player/demo-player.component';
import { ShuffleLanguagesComponent } from '../../components/shuffle-languages/shuffle-languages.component';
import { selectLanguages } from '../../store/languages/languages.selects';
import { Language } from '../../models/language.model';

@Component({
  selector: 'app-landing-page',
  imports: [
    NavbarComponent,
    LucideAngularModule,
    TranslateModule,
    LucideAngularModule,
    PricingComponent,
    ButtonComponent,
    AsyncPipe,
    NgClass,
    OpeningComponent,
    FooterComponent,
    DemoPlayerComponent,
    ShuffleLanguagesComponent,
  ],
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.scss',
})
export class LandingPageComponent {
  private responsiveService: ResponsiveService = inject(ResponsiveService);
  private store: Store = inject(Store);
  public loginService: LoginService = inject(LoginService);
  private route: ActivatedRoute = inject(ActivatedRoute);

  private translateService: TranslateService = inject(TranslateService);

  // :🤳 Responsive
  smallScreen$: Observable<boolean> = this.responsiveService.small$;
  mediumScreen$: Observable<boolean> = this.responsiveService.desktop$;
  largeScreen$: Observable<boolean> = this.responsiveService.largeDesktop$;

  // 💰 Pricing
  currency$: BehaviorSubject<'EUR' | 'DOL'> = new BehaviorSubject<
    'EUR' | 'DOL'
  >('EUR');
  periodicity$: BehaviorSubject<'month' | 'year'> = new BehaviorSubject<
    'month' | 'year'
  >('month');
  free$: Observable<Product | null> = this.store.select(selectFreeProduct);
  pro$: Observable<Product | null> = this.store.select(selectProProduct);
  entreprise$: Observable<Product | null> = this.store.select(
    selectEntrepriseProduct
  );

  // 🖼️ Features
  features: { name: string; imgUrl: string }[] = [
    { name: 'speed', imgUrl: 'https://i.imgur.com/KeUxkct.jpg' },
    { name: 'quality', imgUrl: 'https://i.imgur.com/KeUxkct.jpg' },
    { name: 'multiple_languages', imgUrl: 'https://i.imgur.com/KeUxkct.jpg' },
    // { name: 'multiple_speakers', imgUrl: 'https://i.imgur.com/KeUxkct.jpg' },
    { name: 'realistic_voices', imgUrl: 'https://i.imgur.com/KeUxkct.jpg' },
    { name: 'sounds_level_editing', imgUrl: 'https://i.imgur.com/KeUxkct.jpg' },
    { name: 'easy', imgUrl: 'https://i.imgur.com/KeUxkct.jpg' },
  ];

  // 🌍 Langues pour les composants shuffle (2 listes différentes pour éviter les doublons)
  languagesSet1: string[] = [];
  languagesSet2: string[] = [];

  scrollToElement(element: HTMLElement) {
    element.scrollIntoView({ behavior: 'smooth' });
  }

  ngOnInit() {
    // Charger les langues depuis le store et les diviser en 2 groupes
    this.store.select(selectLanguages).subscribe((languages: readonly Language[]) => {
      const allLanguages = languages.map((lang) => lang.name);
      
      // Mélanger aléatoirement toutes les langues
      const shuffled = [...allLanguages].sort(() => Math.random() - 0.5);
      
      // Diviser en 2 groupes
      const midPoint = Math.ceil(shuffled.length / 2);
      this.languagesSet1 = shuffled.slice(0, midPoint);
      this.languagesSet2 = shuffled.slice(midPoint);
    });

    this.route.queryParams.subscribe((params: Params) => {
      const code: string = params['code'];
      if (code) {
        this.loginService.sendGoogleAuthCode(code).subscribe({
          next: (authRes: AuthRegisterResponse) => {
            this.loginService.login(authRes);
          },
          error: (error) => {
            console.error(error);
          },
        });
      }
    });
  }
}
